module.exports = __webpack_public_path__ + "img/邻里1.c031c194.png";